import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import { Mutation } from "react-apollo";
import { toast } from "react-toastify";
import {
  DELETE_ADMIN_MESSAGE,
  DELETE_ADMIN_MESSAGE_STATUS,
  UPDATE_DEALER_SALES_ASSIGN,
} from "queries";

import { region } from "caniuse-lite";
import { DELETE_DEALER_SALES_ASSIGN } from "pages/Sales/queries";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: "30px",
    "&:focus-visible": {
      outline: "transparent",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    width: "100%",
    marginTop: theme.spacing(2),
  },
}));

function SalesAssignModal({
  region,
  open,
  setOpen,
  collectData,
  reloads,
  salesAssignData,
}) {
  console.log(collectData, region, "collectData", salesAssignData);
  const classes = useStyles();
  const [isSubmit, setIsSubmit] = useState();

  const result = salesAssignData
    ?.filter((assign) => {
      return region?.some(
        (profile) =>
          profile?.profile_id === assign?.profile_id &&
          profile?.matchRegion?.includes(assign?.regions)
      );
    })
    .map(({ profile_id, assign_user_id }) => ({ profile_id, assign_user_id }));
  console.log(result, "result");
  const handleClose = () => {
    setOpen(false);
    setIsSubmit(false);
  };

  const handleAssign = (e, dealerAssignDelete, updateDealer) => {
    e.preventDefault();
    setIsSubmit(true);
    dealerAssignDelete({
      variables: {
        conditions: result?.map((item) => ({
          profile_id: { _eq: item?.profile_id },
          assign_user_id: { _eq: item?.assign_user_id },
        })),
      },
    })
      .then(() => {
        updateDealer({
          variables: {
            profile_ids: collectData?.map((res) => res?.profile_id),
            is_sales_assign: false,
            assign_region: null,
          },
        })
          .then(() => {
            updateDealer({
              variables: {
                profile_ids: region?.map((res) => res?.profile_id),
                is_sales_assign: false,
                assign_region: (() => {
                  const filteredRegions = region?.flatMap((res) =>
                    res?.region?.filter(
                      (item) => !res?.matchRegion?.includes(item)
                    )
                  );
                  return filteredRegions.length > 0
                    ? JSON.stringify(filteredRegions)
                    : null;
                })(),
              },
            })
              .then(() => {
                reloads();
                setIsSubmit(false);
              })
              .catch(() => {
                setIsSubmit(false);
              });
          })
          .catch(() => {
            setIsSubmit(false);
          });
      })
      .catch(() => {
        setIsSubmit(false);
      });
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <div className={classes.paper}>
          <Typography variant="h6" gutterBottom>
            This region has already been assigned to the following Sales Rep:
          </Typography>
          {console.log("Region", region)}

          {region?.length > 0 && (
            <div className={classes.regionList}>
              {region?.map((item, index) => (
                <Typography key={index} variant="body1">
                  {item?.matchRegion?.join(", ")} {"=>"} {item?.name}
                </Typography>
              ))}
            </div>
          )}
          <Typography variant="subtitle1" gutterBottom>
            Are you sure you want to replace this region with the current sales
            assignment?
          </Typography>
          <div className={classes.buttonContainer}>
            <Mutation mutation={DELETE_DEALER_SALES_ASSIGN}>
              {(dealerAssignDelete, { data, loading, called, error }) => {
                if (error)
                  return (
                    <pre>
                      Bad:{" "}
                      {error.graphQLErrors.map(({ message }, i) => (
                        <span key={i}>{message}</span>
                      ))}
                    </pre>
                  );
                return (
                  <Mutation mutation={UPDATE_DEALER_SALES_ASSIGN}>
                    {(updateDealer, { data, loading, called, error }) => {
                      if (error)
                        return (
                          <pre>
                            Bad:{" "}
                            {error.graphQLErrors.map(({ message }, i) => (
                              <span key={i}>{message}</span>
                            ))}
                          </pre>
                        );
                      return (
                        <Button
                          variant="contained"
                          color="secondary"
                          disabled={isSubmit}
                          onClick={(e) =>
                            handleAssign(e, dealerAssignDelete, updateDealer)
                          }
                        >
                          Confirm
                        </Button>
                      );
                    }}
                  </Mutation>
                );
              }}
            </Mutation>
            <Button variant="contained" onClick={handleClose}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default SalesAssignModal;
